import {
  IconExclamationTriangle,
  GreyGrey70,
  Primary13SemiBold,
  YellowYellow10,
  YellowYellow60,
  Box,
  Flex
} from '@sequencehq/core-components'

export const ErrorIcon = (props: { size: 'small' | 'medium' }) => {
  return (
    <Flex
      backgroundColor={YellowYellow10}
      height={props.size === 'small' ? '24px' : '48px'}
      width={props.size === 'small' ? '24px' : '48px'}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
    >
      <IconExclamationTriangle
        color={YellowYellow60}
        size={props.size === 'small' ? '16px' : '24px'}
      />
    </Flex>
  )
}

export const SectionError = (props: {
  text: string
  size: 'small' | 'medium'
}) => {
  return (
    <Flex
      flexDirection={props.size === 'small' ? 'row' : 'column'}
      alignItems="center"
      gap={props.size === 'small' ? '8px' : '16px'}
    >
      <ErrorIcon size={props.size} />
      <Box {...Primary13SemiBold} color={GreyGrey70}>
        {props.text}
      </Box>
    </Flex>
  )
}
